import { TableCell } from '@repo/go-table';
import type { GridRenderCellParams } from '@repo/go-table';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import type { ManualAnomaliesValidationService } from '../services/ManualAnomaliesValidationService';
import type { TManualAnomalyRowData } from '../types';

type Props = {
  params: GridRenderCellParams;
  validationService: ManualAnomaliesValidationService;
  format: (date: Date) => string;
};

export const ManualAnomalyDateCell = observer<Props>(function ManualAnomalyDateCell({
  params,
  validationService,
  format,
}) {
  const date = params.value instanceof Date ? params.value : null;
  const { t } = useTranslation();

  const errors = validationService.errors
    .get(params.id as string)
    ?.[params.field as keyof TManualAnomalyRowData]?.map((error: string) => <p key={error}>{t(error)}</p>);

  return (
    <TableCell
      style={{
        backgroundColor: (!!errors?.length && 'var(--go-table-cell-error-bg-color)') || undefined,
      }}
      message={errors?.length ? errors : undefined}
    >
      {date ? format(date) : '-'}
    </TableCell>
  );
});
